import React, { useState, useContext, useEffect } from "react";
import { Button, CircularProgress } from "@mui/material";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import { ThemeProvider } from "@emotion/react";
import { useParams } from "react-router-dom";
import theme from "../../../themes/theme";
import axios from "axios";
import { AppContext } from "../../../context/AppContext";
import BASE_URL from "../../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import "./CreateLesson.css";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";

const CreateLesson = () => {
  const { id, sectionId } = useParams();
  const [lessonTitle, setLessonTitle] = useState("");
  const [lessonDescription, setLessonDescription] = useState("");
  const [lessonVideoUrl, setLessonVideoUrl] = useState("");
  const [lessonDuration, setLessonDuration] = useState("");
  const [loading, setLoading] = useState(false);
  const [sectionDetails, setSectionDetails] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [tasksEnabled, setTasksEnabled] = useState(true);
  console.log(tasksEnabled);
  const { token } = useContext(AppContext);

  const navigate = useNavigate();
  const navigateToEditLesson = (lessonId) => {
    navigate(`/courses/${id}/sections/${sectionId}/lessons/${lessonId}`);
  };

  const fetchLessons = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLessons(response.data);
    } catch (err) {
      // console.log(err.response.data);
    }
  };

  useEffect(() => {
    const fetchSectionDetails = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/courses/${id}/sections/${sectionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        
        setSectionDetails(response.data.title);
      } catch (err) {
        // console.error("Error fetching section details:", err.message);
      }
    };

    if(token)fetchSectionDetails();
  }, [token]);

  useEffect(() => {
    if(token)fetchLessons();
  }, [id, sectionId]);
  const handleDeleteLesson = async (lessonId) => {
    try {
      await axios.delete(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons/${lessonId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Lesson deleted successfully!");
      fetchLessons();
    } catch (err) {
     
      toast.error("Failed to delete lesson");
    }
  };

  const handleAddLesson = async () => {
    try {
      setLoading(true);

      await axios.post(
        `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons`,
        {
          title: lessonTitle,
          description: lessonDescription,
          videoUrl: lessonVideoUrl,
          duration: lessonDuration,
          tasksEnabled: tasksEnabled,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Lesson added successfully!");
      setLoading(false);
    } catch (err) {
      
      toast.error("Failed to add lesson");
      setLoading(false);
    } finally {
      fetchLessons();
    }
  };

  return (
    <AdminLayout>
      <p className="title" style={{ fontSize: "1.7rem" }}>
        Create new lesson for section
        <br></br>
        {sectionDetails}
      </p>
      <div className="lessons-wrapper">
        <div className="create-form-wrapper">
          <div className="lesson-form">
            <label>Lesson Title</label>
            <Input
              variant="soft"
              placeholder="Enter lesson title"
              value={lessonTitle}
              onChange={(e) => setLessonTitle(e.target.value)}
            />

            <label>Lesson Description</label>
            <Textarea
              minRows={4}
              variant="soft"
              placeholder="Enter lesson description"
              value={lessonDescription}
              onChange={(e) => setLessonDescription(e.target.value)}
            />

            <label>Video URL</label>
            <Input
              variant="soft"
              placeholder="Enter video URL"
              value={lessonVideoUrl}
              onChange={(e) => setLessonVideoUrl(e.target.value)}
            />

            <label>Lesson Duration</label>
            <Input
              variant="soft"
              placeholder="Enter lesson duration"
              value={lessonDuration}
              onChange={(e) => setLessonDuration(e.target.value)}
            />
            <label>Enable tasks</label>
            <div class="checkbox-wrapper-19">
              <input 
                type="checkbox" id="cbtest-19"
                checked={tasksEnabled}
                onChange={(e) => setTasksEnabled(e.target.checked)}
                />
              <label for="cbtest-19" class="check-box" />
            </div>

            <ThemeProvider theme={theme}>
              <Button
                sx={{ marginTop: "10px" }}
                variant="contained"
                color="primary"
                onClick={handleAddLesson}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Add Lesson"}
              </Button>
            </ThemeProvider>
          </div>
        </div>

        {lessons.length > 0 ? (
          <TableContainer
            sx={{ maxWidth: "750px", margin: "auto", marginRight: "20px" }}
            component={Paper}
          >
            <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
              Lessons for this section
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {lessons.map((lesson) => (
                  <TableRow key={lesson._id}>
                    <TableCell>{lesson.title.slice(0, 20)}...</TableCell>
                    <TableCell>{lesson.description.slice(0, 30)}...</TableCell>
                    <TableCell>
                      <ThemeProvider theme={theme}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => navigateToEditLesson(lesson._id)}
                        >
                          Edit lesson
                        </Button>
                      </ThemeProvider>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="delete"
                        onClick={() => handleDeleteLesson(lesson._id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body2" sx={{ mt: 2, marginRight: "20px" }}>
            No lessons available for this section.
          </Typography>
        )}
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
    </AdminLayout>
  );
};

export default CreateLesson;
